import axios from 'axios';
import { styled } from '@mui/system';
import {
  TablePagination,
  tablePaginationClasses as classes,
} from '@mui/base/TablePagination';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

// ! comment this in deployment
// export const BASE_URL = 'http://localhost:9701/api/diy';

// ! uncomment this in deployment
export const BASE_URL = 'https://apis-diycoreservice.mirats.app/api/diy';

export const PUBLISHER_URL =
  'https://api.publisher.miratsquanto.com/api/v1/publisher';
// do comment this in deployment
// export const PUBLISHER_URL = "http://localhost:1234/api/v1/publisher";

export const CIS_BASE_URL = 'https://cis.app.miratsapiservices.com/v2/cis';

// ! comment in below code in production
export const tmpToken = getCookie1('diy_token');
export function getCookie1(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
export function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result?.toLocaleDateString('en-in', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
export const getCurrentSurvey = async (surveyId) => {
  let data = await axios.get(`${BASE_URL}/survey/one?id=${surveyId}`);
  // console.log("getCurrentSurvey=>", data.data);
  return data.data;
};
export const getIPQualityCheck = async (id) => {
  try {
    let data = await axios.get(`${BASE_URL}/session/quality-check/${id}`);
    return data?.data;
  } catch (error) {
    return {
      success: false,
      message: error?.message || 'Unable to do IP quality check !',
    };
  }
};

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function calculatePercentageChange(yesterday, today) {
  if (yesterday == 0 && today == 0) {
    return 0;
  } else if (yesterday == 0) {
    return 100;
  }
  let result = ((today - yesterday) / yesterday) * 100;
  return result.toFixed(2);
}

export function generateRandomName() {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = 'survey-group-';
  for (let i = 0; i < 10; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
export const hideNav = [
  'sign-up',
  'account-disabled',
  'login',
  'DIY',
  'error',
  'verify-change',
  'reset-password',
  '7e08091a73b14e034889265e41ba796f91c766ad',
  '21df0c3543ff3bd23cecdaf921ff4a704a113d06dc1ec21045a186ad0f2f9a42',
  'payment',
  'terms-and-condition',
  'privacy-policy',
  'refund-policy',
  'onboarding',
  '/surveys/',
  '/qualitative-surveys/',
  '/profile/',
  '/e-invoice/',
  'reconciliation-verification',
  'success',
  'transaction-failure',
  '/create-new-supplier',
];
export function timeDifference(ms) {
  const currentTime = new Date().getTime();
  const difference = currentTime - ms;

  const seconds = 1000;
  const minutes = 60 * seconds;
  const hours = 60 * minutes;
  const days = 24 * hours;
  const weeks = 7 * days;
  const months = 30 * days;
  const years = 365 * days;

  if (difference < minutes) {
    return `${Math.floor(difference / seconds)} s`;
  } else if (difference < hours) {
    return `${Math.floor(difference / minutes)} min`;
  } else if (difference < days) {
    return `${Math.floor(difference / hours)} hrs`;
  } else if (difference < weeks) {
    return `${Math.floor(difference / days)} days`;
  } else if (difference < months) {
    return `${Math.floor(difference / weeks)} weeks`;
  } else if (difference < years) {
    return `${Math.floor(difference / months)} months`;
  } else {
    return `${Math.floor(difference / years)} years`;
  }
}
const blue = {
  200: '#A5D8FF',
  400: '#3399FF',
};

const grey = {
  50: '#f6f8fa',
  100: '#eaeef2',
  200: '#d0d7de',
  300: '#afb8c1',
  400: '#8c959f',
  500: '#6e7781',
  600: '#57606a',
  700: '#424a53',
  800: '#32383f',
  900: '#24292f',
};
export const CustomTablePagination = styled(TablePagination)(
  ({ theme }) => `
  & .${classes.spacer} {
    display: none;
  }

  & .${classes.toolbar}  {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
        padding: 0.5em;
          font-size: 14px;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
     font-size: 14px;
  }

  & .${classes.select}{
    padding: 0.1em 1em;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
        border: none;
        font-weight: 700;
        font-size: 14px;
        color: #484848;
        outline: none;
  }

    &:hover {
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
    }

    &:focus {
      outline: 1px solid ${
        theme.palette.mode === 'dark' ? blue[400] : blue[200]
      };
    }
  }

  & .${classes.displayedRows} {
    margin: 0;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${classes.actions} {
    display: flex;
    gap: 0.5rem;
    padding: 0.5em;
    border: none;
  }

  & .${classes.actions} > button {
    padding: 0.1em 1em;
    border: 1px solid #828282;
    cursor: pointer;
    background-color: white;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    border: none;
  }
  `,
);

const STATUS_GROUPS = {
  COMPLETE: 'completes',
  TERMINATE: 'terminate',
  QUALITY: 'qualityTerminate',
  QUOTA: 'quotaFull',
};
export const getRedirectKey = (status) => {
  const s = Number(status);

  switch (true) {
    case s === 10:
      return STATUS_GROUPS.COMPLETE;

    case s >= 20 && s <= 29:
      return STATUS_GROUPS.TERMINATE;

    case s >= 30 && s <= 39:
      return STATUS_GROUPS.QUALITY;

    case s >= 40 && s <= 49:
      return STATUS_GROUPS.QUOTA;

    default:
      console.warn(`Unknown status code: ${s}`);
      return STATUS_GROUPS.TERMINATE;
  }
};

export const buildCallbackUrl = (callbackUrl) => {
  let url = callbackUrl
    ?.replace('[%rid%]', sd.rid)
    ?.replace('[%pub_refid%]', sd.rid)
    ?.replace('[%survey_id%]', surveyNumber || sd.rid);

  url = new URL(url);

  let params = new URLSearchParams(url.search);

  if (params.has('source_id') && data?.source_id) {
    params.set('source_id', data.source_id);
  }

  if (params.has('utm_id') && data?.utm_id) {
    params.set('utm_id', data.utm_id);
  }

  url.search = params.toString();

  return url;
};

export function formateZodError(issues) {
  const errors = {};
  for (const issue of issues) {
    let current = errors;
    issue.path.forEach((key, index) => {
      const isLast = index === issue.path.length - 1;
      if (isLast) {
        current[key] = issue.message;
        return;
      }
      if (!current[key]) {
        current[key] = typeof issue.path[index + 1] === 'number' ? [] : {};
      }
      current = current[key];
    });
  }

  return errors;
}

//get countries:
export const getCountries = async () => {
  try {
    const response = await fetch(
      `${CIS_BASE_URL}/countries?all=true&sort=name&order=asc`,
      {
        method: 'GET',
        redirect: 'follow',
        next: {
          revalidate: 3600,
        },
      },
    );
    if (response.ok) {
      const payload = await response.json();
      const data = Array.isArray(payload?.data) ? payload.data : [];
      const countriesData = data?.map((d) => {
        return {
          label: d?.name,
          value: d?.alpha2Code || d?.alpha3Code,
          icon: d?.emoji,
        };
      });
      return countriesData;
    } else {
      const error = await response.json();
      throw new Error(error?.msg || error?.message || 'An error occurred');
    }
  } catch (error) {
    return error || 'An unknown error occurred';
  }
};

export const getCountryCodes = async () => {
  try {
    const response = await fetch(
      `${CIS_BASE_URL}/countries?all=true&sort=name&order=asc&fields=name,alpha2Code,alpha3Code,emoji,callingCodes`,
      {
        method: 'GET',
        redirect: 'follow',
        next: {
          revalidate: 3600,
        },
      },
    );
    if (response.ok) {
      const payload = await response.json();
      const data = Array.isArray(payload?.data) ? payload.data : [];

      const countriesData = data?.map((d) => {
        return {
          label: d?.name || d?.country_name,
          value: d?.iso2 || d?.alpha2Code || d?.country_code,
          icon: d?.emoji,
          countryCode: d?.callingCodes?.[0],
        };
      });
      return countriesData;
    } else {
      const error = await response.json();
      throw new Error(error?.message || 'An error occurred');
    }
  } catch (error) {
    return error || 'An unknown error occurred';
  }
};
//get states:
export const getStates = async ({ country }) => {
  try {
    if (country !== '' && country) {
      const response = await fetch(
        `${CIS_BASE_URL}/countries/${country}/states?all=true&sort=name&order=asc`,
        {
          method: 'GET',
          redirect: 'follow',
          next: {
            revalidate: 3600,
          },
        },
      );
      if (response.ok) {
        const payload = await response.json();
        const data = (Array.isArray(payload?.data) ? payload.data : []).map(
          (d) => ({
            // ...d,
            label: d?.name || d?.state_name,
            value: d?.state_code || d?.iso2 || d?.stateCode || d?.state_id,
          }),
        );
        return data;
      } else {
        const error = await response.json();
        throw new Error(error?.msg || error?.message || 'An error occurred');
      }
    } else {
      return [];
    }
  } catch (error) {
    // console.log(error);
    return error || 'An unknown error occurred';
  }
};

// get cities:
export const getCities = async ({ country, state }) => {
  try {
    if (country !== '' && state !== '' && country && state) {
      const response = await fetch(
        `${CIS_BASE_URL}/cities?all=true&country_code=${country}&state_code=${state}&sort=city_name&order=asc`,
        {
          method: 'GET',
          redirect: 'follow',
          next: {
            revalidate: 3600,
          },
        },
      );
      if (response.ok) {
        const payload = await response.json();
        const data = (Array.isArray(payload?.data) ? payload.data : []).map(
          (d) => ({
            // ...d,
            label: d?.name || d?.city_name,
            value: d?.name || d?.city_name,
          }),
        );
        return data;
      } else {
        const error = await response.json();
        throw new Error(error?.msg || error?.message || 'An error occurred');
      }
    } else {
      return [];
    }
  } catch (error) {
    // console.log(error);
  }
};
export const SELECT_STYLE = {
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center',
  backgroundSize: '12px',
  paddingRight: '36px',
};

export const detectDevice = () => {
  const ua = navigator.userAgent;
  const isIpadOs =
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const isTablet =
    /iPad|Tablet|PlayBook|Silk/i.test(ua) ||
    (/Android/i.test(ua) && !/Mobile/i.test(ua)) ||
    isIpadOs;
  if (isTablet) return 'tablet';
  if (/Mobi|iPhone|iPod|Android/i.test(ua)) return 'mobile';
  return 'desktop';
};

export const getFormattedDate = (date) => {
  date = date || new Date().toString();
  return new Date(date || '').toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const getDateTime = (date) => {
  date = date || new Date().toString();
  return new Date(date || '')?.toLocaleTimeString('en-ca', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getFormattedDateWithTime = (date) => {
  return `${getFormattedDate(date)} | ${getDateTime(date)}`;
};

export const cn = (...classes) => twMerge(clsx(...classes));

export const currencies = [
  { label: 'US Dollar', value: 'USD', symbol: '$' },
  { label: 'Euro', value: 'EUR', symbol: '€' },
  { label: 'Japanese Yen', value: 'JPY', symbol: '¥' },
  { label: 'British Pound Sterling', value: 'GBP', symbol: '£' },
  { label: 'Australian Dollar', value: 'AUD', symbol: 'A$' },
  { label: 'Canadian Dollar', value: 'CAD', symbol: 'C$' },
  { label: 'Swiss Franc', value: 'CHF', symbol: 'CHF' },
  { label: 'Chinese Yuan Renminbi', value: 'CNY', symbol: '¥' },
  { label: 'Swedish Krona', value: 'SEK', symbol: 'kr' },
  { label: 'New Zealand Dollar', value: 'NZD', symbol: 'NZ$' },
  { label: 'Mexican Peso', value: 'MXN', symbol: '$' },
  { label: 'Singapore Dollar', value: 'SGD', symbol: 'S$' },
  { label: 'Hong Kong Dollar', value: 'HKD', symbol: 'HK$' },
  { label: 'Norwegian Krone', value: 'NOK', symbol: 'kr' },
  { label: 'South Korean Won', value: 'KRW', symbol: '₩' },
  { label: 'Turkish Lira', value: 'TRY', symbol: '₺' },
  { label: 'Russian Ruble', value: 'RUB', symbol: '₽' },
  { label: 'Indian Rupee', value: 'INR', symbol: '₹' },
  { label: 'Brazilian Real', value: 'BRL', symbol: 'R$' },
  { label: 'South African Rand', value: 'ZAR', symbol: 'R' },
  { label: 'Philippine Peso', value: 'PHP', symbol: '₱' },
  { label: 'Czech Koruna', value: 'CZK', symbol: 'Kč' },
  { label: 'Indonesian Rupiah', value: 'IDR', symbol: 'Rp' },
  { label: 'Malaysian Ringgit', value: 'MYR', symbol: 'RM' },
  { label: 'Hungarian Forint', value: 'HUF', symbol: 'Ft' },
  { label: 'Polish Zloty', value: 'PLN', symbol: 'zł' },
  { label: 'Israeli New Shekel', value: 'ILS', symbol: '₪' },
  { label: 'Thai Baht', value: 'THB', symbol: '฿' },
  { label: 'United Arab Emirates Dirham', value: 'AED', symbol: 'د.إ' },
  { label: 'Saudi Riyal', value: 'SAR', symbol: '﷼' },
  { label: 'Chilean Peso', value: 'CLP', symbol: '$' },
  { label: 'Colombian Peso', value: 'COP', symbol: '$' },
  { label: 'Egyptian Pound', value: 'EGP', symbol: '£' },
  { label: 'Vietnamese Dong', value: 'VND', symbol: '₫' },
  { label: 'Romanian Leu', value: 'RON', symbol: 'lei' },
  { label: 'Argentine Peso', value: 'ARS', symbol: '$' },
  { label: 'Pakistani Rupee', value: 'PKR', symbol: '₨' },
  { label: 'Bangladeshi Taka', value: 'BDT', symbol: '৳' },
  { label: 'Nigerian Naira', value: 'NGN', symbol: '₦' },
  { label: 'Qatari Riyal', value: 'QAR', symbol: '﷼' },
  { label: 'Kuwaiti Dinar', value: 'KWD', symbol: 'د.ك' },
  { label: 'Bahraini Dinar', value: 'BHD', symbol: 'ب.د' },
  { label: 'Omani Rial', value: 'OMR', symbol: '﷼' },
  { label: 'Sri Lankan Rupee', value: 'LKR', symbol: 'Rs' },
  { label: 'Kenyan Shilling', value: 'KES', symbol: 'KSh' },
  { label: 'Ghanaian Cedi', value: 'GHS', symbol: '₵' },
  { label: 'Tanzanian Shilling', value: 'TZS', symbol: 'TSh' },
  { label: 'Moroccan Dirham', value: 'MAD', symbol: 'د.م.' },
  { label: 'Jordanian Dinar', value: 'JOD', symbol: 'د.ا' },
  { label: 'Peruvian Sol', value: 'PEN', symbol: 'S/.' },
  { label: 'Uruguayan Peso', value: 'UYU', symbol: '$U' },
  { label: 'Ukrainian Hryvnia', value: 'UAH', symbol: '₴' },
  { label: 'Serbian Dinar', value: 'RSD', symbol: 'дин.' },
  { label: 'Tunisian Dinar', value: 'TND', symbol: 'د.ت' },
  { label: 'Icelandic Krona', value: 'ISK', symbol: 'kr' },
  { label: 'Croatian Kuna', value: 'HRK', symbol: 'kn' },
  { label: 'Mauritian Rupee', value: 'MUR', symbol: '₨' },
  { label: 'Nepalese Rupee', value: 'NPR', symbol: '₨' },
  { label: 'Armenian Dram', value: 'AMD', symbol: '֏' },
  { label: 'Georgian Lari', value: 'GEL', symbol: '₾' },
  { label: 'Kazakhstani Tenge', value: 'KZT', symbol: '₸' },
  { label: 'Azerbaijani Manat', value: 'AZN', symbol: '₼' },
  { label: 'Botswana Pula', value: 'BWP', symbol: 'P' },
  { label: 'Zimbabwean Dollar', value: 'ZWL', symbol: 'Z$' },
  { label: 'Paraguayan Guarani', value: 'PYG', symbol: '₲' },
  { label: 'Bolivian Boliviano', value: 'BOB', symbol: 'Bs.' },
  { label: 'Panamanian Balboa', value: 'PAB', symbol: 'B/.' },
  { label: 'Costa Rican Colón', value: 'CRC', symbol: '₡' },
  { label: 'Honduran Lempira', value: 'HNL', symbol: 'L' },
  { label: 'Guatemalan Quetzal', value: 'GTQ', symbol: 'Q' },
  { label: 'Dominican Peso', value: 'DOP', symbol: 'RD$' },
  { label: 'Trinidad and Tobago Dollar', value: 'TTD', symbol: 'TT$' },
  { label: 'Jamaican Dollar', value: 'JMD', symbol: 'J$' },
  { label: 'Namibian Dollar', value: 'NAD', symbol: 'N$' },
  { label: 'Zambian Kwacha', value: 'ZMW', symbol: 'ZK' },
  { label: 'Malawi Kwacha', value: 'MWK', symbol: 'MK' },
  { label: 'Mozambican Metical', value: 'MZN', symbol: 'MT' },
  { label: 'Rwandan Franc', value: 'RWF', symbol: 'FRw' },
  { label: 'Burundian Franc', value: 'BIF', symbol: 'FBu' },
  { label: 'Congolese Franc', value: 'CDF', symbol: 'FC' },
  { label: 'Algerian Dinar', value: 'DZD', symbol: 'دج' },
  { label: 'Ethiopian Birr', value: 'ETB', symbol: 'Br' },
  { label: 'Cambodian Riel', value: 'KHR', symbol: '៛' },
  { label: 'Laotian Kip', value: 'LAK', symbol: '₭' },
  { label: 'Mongolian Tugrik', value: 'MNT', symbol: '₮' },
  { label: 'North Korean Won', value: 'KPW', symbol: '₩' },
  { label: 'Afghan Afghani', value: 'AFN', symbol: '؋' },
  { label: 'Syrian Pound', value: 'SYP', symbol: '£' },
  { label: 'Lebanese Pound', value: 'LBP', symbol: 'ل.ل' },
  { label: 'Iranian Rial', value: 'IRR', symbol: '﷼' },
  { label: 'Iraqi Dinar', value: 'IQD', symbol: 'ع.د' },
  { label: 'Libyan Dinar', value: 'LYD', symbol: 'ل.د' },
  { label: 'Sudanese Pound', value: 'SDG', symbol: 'ج.س' },
  { label: 'Somali Shilling', value: 'SOS', symbol: 'Sh' },
  { label: 'Seychellois Rupee', value: 'SCR', symbol: '₨' },
  { label: 'Bhutanese Ngultrum', value: 'BTN', symbol: 'Nu.' },
];

export const defaultRowsPerPage = 15;

export const rowsPerPageOptions = [15, 25, 50, 100];

export const defaultPage = 1;

export const defaultRedisCacheExpiration = 1800; // 30 minutes

export const LocationTypes = [
  'billing',
  'shipping',
  'office',
  'headquarters',
  'other',
];

export const bankAccountTypes = ['savings', 'current'];
